import { CdkCopyToClipboard } from '@angular/cdk/clipboard'
import { ChangeDetectionStrategy, Component, signal } from '@angular/core'

import { ICellRendererAngularComp } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community'
import { TooltipModule } from 'primeng/tooltip'

import { FlxIconComponent } from '@flowx/angular-ui-toolkit'
import { FlxClickStopPropagationDirective } from '@flowx/designer/modules/core/directives/stop-propagation.directive'

@Component({
  imports: [TooltipModule, CdkCopyToClipboard, FlxIconComponent, FlxClickStopPropagationDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: 'process-uuid.component.html',
})
export class ProcessUuidComponent implements ICellRendererAngularComp {
  uuid = signal<string>('')
  isSubprocess = signal<boolean>(false)
  copied = signal<boolean>(false)

  agInit(params: ICellRendererParams): void {
    this.uuid.set(params.value ?? '')
    this.isSubprocess.set(params.data?.isSubprocess ?? false)
  }

  refresh(params: ICellRendererParams): boolean {
    this.uuid.set(params.value ?? '')
    this.isSubprocess.set(params.data?.isSubprocess ?? false)
    return true
  }

  copyUuidSuccess(): void {
    this.copied.set(true)
    setTimeout(() => this.copied.set(false), 1500)
  }
}
